<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editFormRef" label-width="118px">
        <el-form-item label="姓名" class="addAdminForm">
          <el-input v-model="editForm.anliname" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="缩略图" class="addAdminForm">
          <TencentyunCosUploadImg :propsimageUrl="editForm.newsavatar" @change="changeTencentyunCosUploadImg"></TencentyunCosUploadImg>
        </el-form-item>
        <el-form-item label="体验前右眼视力" class="addAdminForm">
          <el-input v-model="editForm.anlifr" placeholder="请输入体验前右眼视力"></el-input>
        </el-form-item>
        <el-form-item label="体验前左眼视力" class="addAdminForm">
          <el-input v-model="editForm.anlifl" placeholder="请输入体验前左眼视力"></el-input>
        </el-form-item>
        <el-form-item label="体验后右眼视力" class="addAdminForm">
          <el-input v-model="editForm.anlibr" placeholder="请输入体验后右眼视力"></el-input>
        </el-form-item>
        <el-form-item label="体验后左眼视力" class="addAdminForm">
          <el-input v-model="editForm.anlibl" placeholder="请输入体验后左眼视力"></el-input>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select v-model="editForm.istop" placeholder="请选择" class="select">
            <el-option label="置顶" value="1"></el-option>
            <el-option label="不置顶" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细内容">
          <VueUeditorWrap v-model="editForm.newsinfo" :config="myConfig"></VueUeditorWrap>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="clickSave">保存</el-button>
          <el-button type="info" @click="backCases">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadImg,
    VueUeditorWrap
  },
  data () {
    return {
      editForm: {
        istop: '2',
        newsavatar: '',
        anliname: '',
        anlifr: '',
        anlifl: '',
        anlibr: '',
        anlibl: '',
        newsinfo: ''
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata

      this.editForm.istop = this.parentdata.params.istop
      this.editForm.newsavatar = this.parentdata.params.newsavatar
      this.editForm.anliname = this.parentdata.params.anliname
      this.editForm.anlifr = this.parentdata.params.anlifr
      this.editForm.anlifl = this.parentdata.params.anlifl
      this.editForm.anlibr = this.parentdata.params.anlibr
      this.editForm.anlibl = this.parentdata.params.anlibl
      this.editForm.newsinfo = this.parentdata.params.newsinfo
    },
    changeTencentyunCosUploadImg (url) {
      this.editForm.newsavatar = url
    },
    backCases () {
      this.$emit('triggerFunc', '')
    },
    clickSave () {
      this.apiEditCases()
    },
    apiEditCases: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newsid: this.parentdata.params.newsid,
        istop: that.editForm.istop,
        newsavatar: that.editForm.newsavatar,
        anliname: that.editForm.anliname,
        anlifr: that.editForm.anlifr,
        anlifl: that.editForm.anlifl,
        anlibr: that.editForm.anlibr,
        anlibl: that.editForm.anlibl,
        newsinfo: that.editForm.newsinfo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditCases, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
    margin-right: 20px;
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/ .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.upload{
    display: flex;
    padding-top: 15px;
    align-items: center;
}
.quill-editor{
    height: 300px;
}

/deep/ .el-form-item__content {
    line-height: 20px;
}
</style>
